export const membershipMetricOptions = [
  {
    name: "Status",
    id: "status",
    metric: "NumberOfMembersByStatus"
  },
  {
    name: "ClubReady Profile",
    id: "clubReadyProfile",
    metric: "NumberOfMembersByProfile"
  },
  {
    name: "Paying",
    id: "paying",
    metric: "NumberOfPayingMembersByPricingOption"
  },
  {
    name: "Paying Excluding Zero Sales",
    id: "payingExcludingZeroSales",
    metric: "NumberOfPayingMembersByPricingOptionExcludingZeroSales"
  },
  {
    name: "Membership Type",
    id: "membershipType",
    metric: "MembersByMembershipType"
  }
];

export const MEMBERSHIP_METRIC_MAPPING = {
  NumberOfMembersByStatus: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Status"
  },
  NumberOfMembersByProfile: {
    availableOptions: ["ClubReady Profile"],
    selectedOptionByDefault: "ClubReady Profile"
  },
  NumberOfPayingMembersByPricingOption: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Paying"
  },
  NumberOfPayingMembersByPricingOptionExcludingZeroSales: {
    availableOptions: [
      "Status",
      "ClubReady Profile",
      "Paying",
      "Paying Excluding Zero Sales",
      "Membership Type"
    ],
    selectedOptionByDefault: "Paying Excluding Zero Sales"
  }
};

export const METRIC_PARAMS = {
  NumberOfMembersByStatus: {
    apiPath: "by_status",
    showPosModal: true
  },
  NumberOfMembersByProfile: {
    apiPath: "by_profile",
    showPosModal: false
  },
  NumberOfPayingMembersByPricingOption: {
    apiPath: "paying_by_pricing_option",
    showPosModal: true
  },
  NumberOfPayingMembersByPricingOptionExcludingZeroSales: {
    apiPath: "paying_by_pricing_option_excluding_zero_sales",
    showPosModal: true
  },
  MembersByMembershipType: {
    apiPath: "by_membership_type",
    showPosModal: false
  }
};
